{
  "browserNotSupported": {
    "title": "Не удалось загрузить модуль",
    "text": "Чтобы использовать браузер частей перейдите в актуальную версию браузера."
  },
  "main": {
    "more": "Дополнительные аксессуары",
    "findMore": "Здесь, в нашем обширном ассортименте, вы можете найти аксессуары для дооснащения/преобразования и модернизации вашего автомобиля. Выбранные вами аксессуары будут отправлены вашему {{brand}}-партнеру вместе с запросом автомобиля.",
    "topOffers": "ТОП предложения",
    "article": "<0>{{min}} - {{max}} / </0>{{productCount}} Продукты",
    "noArticleFound": "0 Продукты",
    "oemHint": "Выберите подходящие аксессуары для вашего {{brand}} прямо сейчас!",
    "noBrand": "Выберите подходящие аксессуары для вашего автомобиля прямо сейчас!",
    "outOfOrder": "К сожалению, на данный момент в наличии нет продукции.<0/>В настоящее время мы обновляем наш каталог.<0/>Пожалуйста, посетите нас снова позднее.",
    "nextSlide": "Следующий",
    "prevSlide": "Предыдущий"
  },
  "cart": {
    "add": "Товар добавлен в автомобиль",
    "fullPrice": "Цена автомобиля и аксессуаров",
    "priceWithoutCar": "Ценовые аксессуары"
  },
  "navigation": {
    "zoom": "Увеличить",
    "toggleSearch": "Переключить поиск",
    "cart": "Корзина",
    "cartDelete": "Удалить товар из корзины",
    "vehicle": "Выбранный Автомобиль",
    "maxBookmarksReached": "Достигается максимум 15 продуктов",
    "filter": {
      "toggleFilter": "Переключить фильтр",
      "topProducts": "ТОП предложения",
      "reset": "Сбросить фильтр",
      "ready": "Готово",
      "show": "Показать результаты"
    },
    "searching": {
      "submit": "Отправить",
      "close": "Закрыть",
      "placeholder": "Найдите подходящие аксессуары ...",
      "suggestions": "Варианты поиска",
      "categories": "Категории",
      "products": "Товары",
      "productCount": "{{count}} товар",
      "productCount_one": "{{count}} товар",
      "productCount_few": "{{count}} товара",
      "productCount_many": "{{count}} товаров",
      "showAll": "Показать {{count}} результат",
      "showAll_one": "Показать {{count}} результат",
      "showAll_few": "Показать все {{count}} результата",
      "showAll_many": "Показать все {{count}} результатов",
      "expand": "Расширенный Поиск",
      "show": "Продукт для демонстрации",
      "found": {
        "withCategory": "Результаты поиска \"{{fuzzy}}\" в категории \"{{category}}\"",
        "withOutCategory": "Результаты поиска \"{{fuzzy}}\" из всех категорий"
      }
    },
    "share": "Поделиться",
    "back": "Назад",
    "details": "детали",
    "add": "Добавить",
    "remove": "Удалить",
    "close": "Закрыть",
    "filtern": "фильтр",
    "closeFilter": "Закрыть фильтр"
  },
  "productDetail": {
    "gallery": {
      "jumpToImageNumber": "Перейти к изображению {{number}}"
    },
    "articleNumber": "Номер артикула",
    "relatedArticle": "Вам могут быть интересны также следующие продукты:",
    "brand": "Бренд",
    "priceBox": {
      "withVatAndMounting": "вкл. НДС и монтаж",
      "withVat": "вкл. НДС",
      "recommendedRetailPrice": "Рекомендуемая розничная цена",
      "historicMinimalPurchasePrice": "Минимальная цена за последние 30 дней",
      "priceDetails": "Подробности о цене",
      "priceDetailsHeadline": "Подробности о цене для этого товара",
      "priceToday": "Цена для этого товара сегодня",
      "priceDetails30Days": "Самая низкая цена в течение 30 дней до изменения цены",
      "close": "Закрыть",
      "addItem": "Добавить продукт",
      "removeItem": "Удалить продукт"
    },
    "infoBox": {
      "description": "Описание",
      "vehicles": "Подходит для следующих моделей",
      "empty": "Для данного продукта не существует специальных назначений для транспортных средств.",
      "contacts": "Производитель"
    },
    "contacts": {
      "manufacturer-contact": "Контактная информация производителя",
      "responsible-contact": "Ответственное лицо в ЕС",
      "trademark": "марка"
    }
  },
  "productList": {
    "oemHint": "Оригинальные аксессуары для вашего {{brand}}"
  }
}
